import React from 'react';
import { Link } from 'react-router-dom';
import styles from "./styles.module.css";

interface CustomButtonProps {
    text: React.ReactNode;
    to?: string;
    theme?: "primary" | "outlined";
    size?: "sm" | "mid" | "lg";
    className?: string;
    onClick?: () => void;
    disabled?: boolean;
    type?: "button" | "submit" | "reset"; // ✅ added
}

const CustomButton: React.FC<CustomButtonProps> = ({
    text,
    to,
    theme = "primary",
    size = "mid",
    className = "",
    onClick,
    disabled = false,
    type = "button", // ✅ default to button
}) => {
    const buttonClass = styles[`btn_${theme}`];
    const sizeClass = styles[`btn_${size}`];
    const disabledClass = disabled ? styles.btn_disabled : "";
    const combinedClass = `${styles.btn} ${buttonClass} ${sizeClass} ${disabledClass} ${className}`;

    const isExternal = to && /^(https?:)?\/\//i.test(to);

    if (to && !disabled) {
        if (isExternal) {
            return (
                <a
                    href={to}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={combinedClass}
                    onClick={onClick}
                >
                    {text}
                </a>
            );
        }

        return (
            <Link to={to} className={combinedClass} onClick={onClick}>
                {text}
            </Link>
        );
    }

    return (
        <button
            type={type} // ✅ use prop here
            className={combinedClass}
            onClick={onClick}
            disabled={disabled}
        >
            {text}
        </button>
    );
};

export default CustomButton;
